(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // WP — #56: curated tag chips drive the existing tag facet in-page. Clicking a
  // chip proxy-clicks the matching filter checkbox (value match avoids selector
  // escaping), which triggers the facets AJAX. Delegated once on document; the
  // chip row + active state re-render server-side with the results section.
  document.addEventListener('click', (e) => {
    const chip = e.target.closest && e.target.closest('[data-wp-tag-chip]');
    if (!chip) return;
    e.preventDefault();
    const tag = chip.getAttribute('data-tag');
    let target = null;
    document.querySelectorAll('input[name="filter.p.tag"]').forEach((i) => {
      if (i.value === tag) target = i;
    });
    if (target) {
      target.click();
      // FL-006: tag chips now live in the masthead header (a separate section that
      // doesn't re-render on the facet AJAX), so reflect the new state on the chip
      // optimistically. Chips inside the results section get replaced by the
      // server-rendered state on re-render, so this is harmless there.
      chip.classList.toggle('is-active', target.checked);
      chip.setAttribute('aria-pressed', target.checked ? 'true' : 'false');
    }
  });

  // WP: two-way sync. The curated tag chips (pills OR thumbnail cards) live in the
  // masthead header, a SEPARATE section that does NOT re-render on the facet AJAX — so
  // a change made in the left filter menu (unchecking a tag, Clear all, removing an
  // active-value chip) would otherwise leave the chips stale. Every filter change
  // dispatches ThemeEvents.FilterUpdate ('filter:update') on document with the new
  // query params; re-derive each chip's active state from the active filter.p.tag
  // values so the menu and the custom tag section never drift apart. (Chip clicks also
  // route through here via the proxy-click above, making the server state authoritative.)
  const wpSyncTagChips = (activeTags) => {
    document.querySelectorAll('[data-wp-tag-chip]').forEach((chip) => {
      const on = activeTags.indexOf(chip.getAttribute('data-tag')) !== -1;
      chip.classList.toggle('is-active', on);
      chip.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  };
  document.addEventListener('filter:update', (e) => {
    const params = (e.detail && e.detail.queryParams) || new URLSearchParams(window.location.search);
    wpSyncTagChips(params.getAll('filter.p.tag'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wild-logos"] && !Shopify.designMode) return;
  try {
    
  // WP-PERF: only run the logo marquee while it's in (or near) the viewport. An
  // always-on infinite animation keeps the main thread painting for the whole
  // session and blows up Lighthouse Speed Index / TTI. Start paused; the observer
  // resumes it when the strip scrolls into view and pauses it again once it leaves.
  (function () {
    if (!('IntersectionObserver' in window)) return;
    function bind(track) {
      var viewport = track.closest('.wild-logos__viewport');
      if (!viewport) return;
      track.classList.add('wild-logos__track--offscreen');
      new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          track.classList.toggle('wild-logos__track--offscreen', !entries[i].isIntersecting);
        }
      }, { rootMargin: '200px 0px' }).observe(viewport);
    }
    function init() {
      document.querySelectorAll('.wild-logos__track').forEach(bind);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wild-ugc"] && !Shopify.designMode) return;
  try {
    
  // Desktop mouse drag-to-scroll (touch is native). Engages only after >6px so
  // plain clicks on a card link still pass through. Scoped to this section's track.
  (function () {
    document.querySelectorAll('[data-ugc-track]').forEach(function (track) {
      if (track.dataset.ugcBound) return;
      track.dataset.ugcBound = '1';
      var down = false, moved = false, startX = 0, startScroll = 0;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        down = true; moved = false; startX = e.clientX; startScroll = track.scrollLeft;
      });
      track.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (!moved && Math.abs(dx) > 6) { moved = true; track.classList.add('is-dragging'); track.setPointerCapture(e.pointerId); }
        if (moved) track.scrollLeft = startScroll - dx;
      });
      function end() { down = false; if (moved) setTimeout(function () { track.classList.remove('is-dragging'); }, 0); }
      track.addEventListener('pointerup', end);
      track.addEventListener('pointercancel', end);
      track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
